<svg width="64" height="64" viewBox="43 31 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g filter="url(#filter0_d_17024_14640)">
<path d="M75 33.8574C91.0952 33.8574 104.143 46.9048 104.143 63C104.143 79.0952 91.0952 92.1426 75 92.1426C58.9048 92.1426 45.8574 79.0952 45.8574 63C45.8574 46.9048 58.9048 33.8574 75 33.8574Z" stroke="url(#paint0_linear_17024_14640)" stroke-width="1.71429" shape-rendering="crispEdges"/>
<use href="#stroke0_17024_14640" xlink:href="#stroke0_17024_14640" fill="#04051B"/>
<use href="#stroke0_17024_14640" xlink:href="#stroke0_17024_14640" fill="url(#paint1_radial_17024_14640)"/>
</g>
<defs>
<filter id="filter0_d_17024_14640" x="0" y="0" width="150" height="150" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="12"/>
<feGaussianBlur stdDeviation="22.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17024_14640"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_17024_14640" result="shape"/>
</filter>
<linearGradient id="paint0_linear_17024_14640" x1="75" y1="33" x2="75" y2="93" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFE111"/>
<stop offset="1" stop-color="#FFA100"/>
</linearGradient>
<radialGradient id="paint1_radial_17024_14640" cx="0" cy="0" r="1" gradientTransform="matrix(27.8991 -12.6281 2.78295 50.0018 61.2939 70.3915)" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFEB14"/>
<stop offset="1" stop-color="#FFA100"/>
</radialGradient>
<path id="stroke0_17024_14640" d="M70.1082 69.3L87.0582 52.35C87.4582 51.95 87.9248 51.75 88.4582 51.75C88.9915 51.75 89.4582 51.95 89.8582 52.35C90.2582 52.75 90.4582 53.2253 90.4582 53.776C90.4582 54.3267 90.2582 54.8013 89.8582 55.2L71.5082 73.6C71.1082 74 70.6415 74.2 70.1082 74.2C69.5748 74.2 69.1082 74 68.7082 73.6L60.1082 65C59.7082 64.6 59.5162 64.1253 59.5322 63.576C59.5482 63.0267 59.7568 62.5513 60.1582 62.15C60.5595 61.7487 61.0348 61.5487 61.5842 61.55C62.1335 61.5513 62.6082 61.7513 63.0082 62.15L70.1082 69.3Z"/>
</defs>
</svg>
